import React, { useState } from 'react';
import styles from './menu.module.scss';
import MenuImage from 'assets/images/menu-image.png';
import MenuImageSp from 'assets/images/menu-image-sp.png';
import { Link } from 'react-router-dom';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import { ReactComponent as LogoWhiteSvg } from 'assets/images/logo.svg';
import { REGISTER_FORM_URL } from 'const';
import classNames from 'classnames';

export const Menu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const clickBtn = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'click', {
        action: 'サポーター登録ボタンクリック(ヘッダー)',
      });
    }
    window.open(REGISTER_FORM_URL, '_blank');
  };
  return (
    <>
      <button
        className={`${styles.menuButton} ${isOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label="メニュー"
      >
        <span className={styles.menuIcon}></span>
      </button>
      <div className={`${styles.menuOverlay} ${isOpen ? styles.open : ''}`}>
        <div className={styles.menuContent}>
          <div className={styles.logoBlock}>
            <Link to={'/#top'}>
              <LogoWhiteSvg className={styles.logo} />
            </Link>
            <button className={styles.link} onClick={clickBtn}>
              サポーター登録はこちら
              <GreenCircleArrow className={styles.icon} />
            </button>
          </div>
          <div className={styles.menuNav}>
            <ul>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/">
                  <div className={styles.menuLinkInner}>
                    <p>TOP</p>
                    <span>P-manのTOPページ</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/about">
                  <div className={styles.menuLinkInner}>
                    <p>WHAT’S P-man</p>
                    <span>ピーマンとは</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/p-man-comic">
                  <div className={styles.menuLinkInner}>
                    <p>P-man4コマ劇場</p>
                    <span>4コマ漫画でわかるP-manライフ</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/worries">
                  <div className={styles.menuLinkInner}>
                    <p>WORRIES</p>
                    <span>ペットとペットオーナーの悩み</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/news-list">
                  <div className={styles.menuLinkInner}>
                    <p>お知らせ</p>
                    <span>P-manからのお知らせやペットフレンドリー物件情報</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/supporters-voice">
                  <div className={styles.menuLinkInner}>
                    <p>SUPPORTER’S VOICE</p>
                    <span>サポーターにエントリーいただいた皆さまの声</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
              <li className={styles.menuItem}>
                <Link className={styles.menuLink} to="/faq">
                  <div className={styles.menuLinkInner}>
                    <p>FAQ</p>
                    <span>よくある質問</span>
                  </div>
                  <GreenCircleArrow className={styles.icon} />
                </Link>
              </li>
            </ul>
            <p className={styles.menuFooter}>本件は事業化検討段階のため内容が<br className={styles.spOnly} />変更となる場合があります</p>
          </div>
          <img
            src={MenuImage}
            alt="メニュー画像"
            className={classNames(styles.menuImage, styles.pcOnly)}
          />
          <img
            src={MenuImageSp}
            alt="メニュー画像"
            className={classNames(styles.menuImage, styles.spOnly)}
          />
        </div>
      </div>
    </>
  );
};

export default Menu; 